import { changeAppState, getAppState } from "../../../../common/appState";

export function openOtherUserPanel(
    targetUserId: number,
    fncAfterUpdated?: () => void
) {
    const { otherUserPanelsState } = getAppState();
    const currentState = otherUserPanelsState.find(
        state => state.targetUserId === targetUserId
    );
    if (currentState) {
        changeAppState(
            "otherUserPanelsState",
            otherUserPanelsState.map(state =>
                state.targetUserId === targetUserId
                    ? {
                          ...state,
                          open: true,
                          scrollToTop: true,
                          fncAfterUpdated: () => {
                              currentState.fncAfterUpdated?.();
                              fncAfterUpdated?.();
                          },
                      }
                    : state
            )
        );
        return;
    }
    changeAppState("otherUserPanelsState", [
        ...otherUserPanelsState,
        {
            targetUserId,
            open: true,
            fncAfterUpdated,
        },
    ]);
}
